import { render, staticRenderFns } from "./Practices.vue?vue&type=template&id=4381c399&scoped=true&"
import script from "./Practices.vue?vue&type=script&lang=js&"
export * from "./Practices.vue?vue&type=script&lang=js&"
import style0 from "./Practices.vue?vue&type=style&index=0&id=4381c399&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4381c399",
  null
  
)

export default component.exports